export default "/images/vendor/flag-icon-css/flags/1x1/mc.svg?082fc1558b4cf726b6130f863131d635";